import { render, staticRenderFns } from "./VerificationOtp.vue?vue&type=template&id=e1578784&scoped=true"
import script from "./VerificationOtp.vue?vue&type=script&lang=js"
export * from "./VerificationOtp.vue?vue&type=script&lang=js"
import style0 from "./VerificationOtp.vue?vue&type=style&index=0&id=e1578784&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1578784",
  null
  
)

export default component.exports